import screenLinkTemplate from './screenLink.ejs';
import styles from './styles.less';

interface ScreenLinkData {
    action?: string;
    meta?: string;
    screen?: string;
}

export default function(data: ScreenLinkData) {
    return screenLinkTemplate({
        ...data,
        styles,
    });
}
